import {ActionType, createAction} from 'typesafe-actions';
import {AccessDTO} from '../../generated/PortalApiClient';

export const accessModuleStoreAccessData = createAction(
    'ACCESS_MODULE_STORE_ACCESS_DATA',
    (action) => (access: AccessDTO) => action({access})
);

export type AccessModuleActionTypes = ActionType<typeof accessModuleStoreAccessData>;
